export default "__VITE_ASSET__BYh0b7pS__"